import { useTranslation } from 'react-i18next'
import { WarningIcon } from './icons/WarningIcon'

interface ToastProps {
  message: string
  onDismiss: () => void
  variant?: 'error' | 'warning'
  topRight?: boolean
  iconOnly?: boolean
}

export function Toast({ message, onDismiss, variant = 'error', topRight, iconOnly }: ToastProps) {
  const { t } = useTranslation()
  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`toast toast-${variant}${topRight ? ' toast-top-right' : ''}`}
    >
      {iconOnly ? (
        <span className={`toast-label ${variant}`} style={{ flexShrink: 0, display: 'inline-flex' }}>
          <WarningIcon size={16} />
        </span>
      ) : (
        <span className={`toast-label ${variant}`}>
          {variant === 'warning' ? t('toast.warningLabel') : t('toast.errorLabel')}
        </span>
      )}
      <span style={{ flex: 1, color: 'var(--text-primary)' }}>{message}</span>
      <button
        onClick={onDismiss}
        aria-label={t('toast.dismiss')}
        className="icon-btn"
        style={{ fontSize: 16, lineHeight: 1 }}
      >
        ✕
      </button>
    </div>
  )
}
